<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<b-tabs>
					<b-tab title="Параметры" active>
						<p>
						<button type="button" class="btn btn-light" @click="back">Назад</button>
						<button type="button" class="btn btn-success" @click="saveClickHandler">Сохранить</button>
						<button type="button" class="btn btn-info" @click="openWindow">Просмотр в браузере</button>
						<button type="button" class="btn btn-warning" @click="saveSendsay">Выгрузить</button>
						</p>
						<form action="">
							<div class="form-row">
								<div class="form-group col-md-2">
									<div class="input-group mb-1 mr-sm-1">
										<div class="input-group-prepend">
											<div class="input-group-text">ID</div>
										</div>
										<input type="text" class="form-control" v-model="tableData.id" readonly>
									</div>
								</div>
								<div class="form-group col-md-4">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
											<div class="input-group-text">Дата создания</div>
										</div>
										<input type="text" class="form-control" v-model="tableData.date" readonly>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-6">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
										<div class="input-group-text">Наименование</div>
										</div>
										<input type="text" class="form-control" v-model="tableData.name">
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-6">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
										<div class="input-group-text">Имя отправителя</div>
										</div>
										<select class="form-control" v-model="tableData.sender_name">
											<option value="Владимир Туров">Владимир Туров</option>
											<option value="Блог о налогах Турова">Блог о налогах Турова</option>
											<option value="Школа Бизнеса Турова">Школа Бизнеса Турова</option>
										</select>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-3">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
											<div class="input-group-text">Email отправителя</div>
										</div>
										<input type="text" class="form-control" v-model="tableData.sender_email">
									</div>
								</div>
								<div class="form-group col-md-3">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
											<div class="input-group-text">Email для ответа</div>
										</div>
										<input type="text" class="form-control" v-model="tableData.sender_reply_to">
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-6">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
										<div class="input-group-text">Тема письма</div>
										</div>
										<input type="text" class="form-control" v-model="tableData.subject">
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-6">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
										<div class="input-group-text">Прехеддер</div>
										</div>
										<input type="text" class="form-control" v-model="tableData.preheader">
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-6">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
										<div class="input-group-text">Ссылка</div>
										</div>
										<input type="text" class="form-control" v-model="tableData.url">
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-6">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
										<div class="input-group-text">Текст кнопки с призывом</div>
										</div>
										<input type="text" class="form-control" v-model="tableData.text_more">
									</div>
								</div>
							</div>
							<div class="form-group">
								<div class="form-check">
								<label class="form-check-label">
									<input class="form-check-input" type="checkbox" true-value="1"  false-value="0" v-model="tableData.is_promo"> Промо рассылка
								</label>
								</div>
							</div>
						</form>
					</b-tab>
					<b-tab title="Дизайн">
						<p>
						<button type="button" class="btn btn-light" @click="back">Назад</button>
						<button type="button" class="btn btn-success" @click="saveClickHandler">Сохранить</button>
						<button type="button" class="btn btn-info" @click="openWindow">Просмотр в браузере</button>
						<button type="button" class="btn btn-warning" @click="saveSendsay">Выгрузить</button>
						</p>
							<attachment-form :id=id></attachment-form>
					</b-tab>
					<b-tab title="Письмо">
						<p>
						<button type="button" class="btn btn-light" @click="back">Назад</button>
						<button type="button" class="btn btn-success" @click="saveClickHandler">Сохранить</button>
						<button type="button" class="btn btn-info" @click="openWindow">Просмотр в браузере</button>
						<button type="button" class="btn btn-warning" @click="saveSendsay">Выгрузить</button>
						</p>
							<ckeditor :editor="editor" v-model="tableData.text"></ckeditor>
					</b-tab>
					<b-tab title="Доп.Новости">
						<p>
						<button type="button" class="btn btn-light" @click="back">Назад</button>
						<button type="button" class="btn btn-success" @click="saveClickHandler">Сохранить</button>
						<button type="button" class="btn btn-info" @click="openWindow">Просмотр в браузере</button>
						<button type="button" class="btn btn-warning" @click="saveSendsay">Выгрузить</button>
						</p>
						<add-news :id="id" ref="news"></add-news>
					</b-tab>
					<b-tab title="Мероприятия">
						<p>
						<button type="button" class="btn btn-light" @click="back">Назад</button>
						<button type="button" class="btn btn-success" @click="saveClickHandler">Сохранить</button>
						<button type="button" class="btn btn-info" @click="openWindow">Просмотр в браузере</button>
						<button type="button" class="btn btn-warning" @click="saveSendsay">Выгрузить</button>
						</p>
						<add-event :id="id" ref="event"></add-event>
					</b-tab>
					<b-tab title="Вебинары">
						<p>
						<button type="button" class="btn btn-light" @click="back">Назад</button>
						<button type="button" class="btn btn-success" @click="saveClickHandler">Сохранить</button>
						<button type="button" class="btn btn-info" @click="openWindow">Просмотр в браузере</button>
						<button type="button" class="btn btn-warning" @click="saveSendsay">Выгрузить</button>
						</p>
						<add-webinar :id="id" ref="webinar"></add-webinar>
					</b-tab>
				</b-tabs>
			</div>
		</div>
	</div>
</template>
<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import AttachmentForm from '@/components/mailing/AttachmentForm'
import News from '@/components/mailing/News'
import Events from '@/components/mailing/Events'
import Webinars from '@/components/mailing/Webinars'
import Templates from '@/components/mailing/Templates'

export default {
	components: {
		'attachment-form': AttachmentForm,
		'add-news': News,
		'add-event': Events,
		'add-webinar': Webinars,
		'data-templates': Templates
	},
	data () {
		return {
			id: '',
			tableData: [],
			editor: ClassicEditor,
			editorData: '<p>Content of the editor.</p>'
		}
	},
	created () {
		this.id = parseInt(this.$route.params.id)
		this.getMailing()
	},
	mounted () {
	},
	methods: {
		getMailing () {
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/mailings/' + this.id, {}, {
			}).then(function (response) {
				this.tableData = response.body
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		saveClickHandler () {
			let data = Object.assign({}, this.tableData)
			this.$store.commit('CALL_API_ON')
			this.$http.put(this.$store.state.apiURL + '/v1/mailings/' + this.id, data, {
			}).then(function (response) {
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
			this.$refs.news.saveEvent()
			this.$refs.event.saveEvent()
			this.$refs.webinar.saveEvent()
		},
		back () {
			history.back()
			return false
		},
		openWindow: function () {
			window.open('https://turovschool.ru/mail/' + this.id, '_blank')
		},
		saveSendsay: function () {
			this.$store.commit('CALL_API_ON')
			this.$http.put(this.$store.state.apiURL + '/v1/mailing/templates/' + this.id, {type: 'yes'}, {
				headers: {
					'content-type': 'application/json'
				}
			}).then(function (response) {
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/mailing/create.vue